module.exports = __webpack_public_path__ + "assets/img/5_1315.b8901a79.jpg";